import urlParse from 'url-parse';

export function formatUrl(url: string) {
  const urlObject = urlParse(url, /* do not use browser environment */ {}, /* parse query */ false);
  return urlObject.href;
}
